import { defer, from, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthTokenService } from './auth-token.service';
import { environment } from 'src/environments/environment';

/** Web Locks serialize refresh across tabs sharing this origin's auth storage. */
export function coordinateRefresh(
  tokens: AuthTokenService,
  failedAccessToken: string | null,
  refresh: () => Observable<string>
): Observable<string> {
  return defer(() => {
    const run = () => {
      const current = tokens.getAccessToken();
      // A different request/tab already recovered the failed bearer.
      if (current && current !== failedAccessToken) {
        return Promise.resolve(current);
      }
      // Logout in another tab must not be undone by a queued refresh.
      if (failedAccessToken && !current) {
        return Promise.reject(new Error('Authentication changed while waiting for refresh.'));
      }
      return refresh().pipe(take(1)).toPromise();
    };
    const locks = typeof navigator !== 'undefined' && (navigator as any).locks;
    // Older browsers retain single-instance single-flight. The server still
    // rejects replay, without deleting a cookie installed by another tab.
    return from<string>(locks
      ? locks.request('daro-auth-refresh:' + environment.BaseUrl, { mode: 'exclusive' }, run)
      : run());
  });
}
